// Generated by ReScript, PLEASE EDIT WITH CARE


var Detail;

var title = {
  id: "7b6df001-0b2c-4592-9494-2e9d8257c620",
  defaultMessage: "Quotas VE"
};

var dealerName = {
  id: "a8b9d4ee-b8ea-4bba-9325-9521e92fcb70",
  defaultMessage: "Dealer name"
};

var createQuotaButton = {
  id: "04ccb004-71ec-4812-b2b5-e6df388b2345",
  defaultMessage: "Create/Import Quotas"
};

var modalTitle = {
  id: "d285b65d-a401-454b-b496-68eee0a505bf",
  defaultMessage: "VE Quota Management"
};

var createQuota = {
  id: "063ec711-079b-4f9f-9bbe-3a5bd8a9c6e2",
  defaultMessage: "Enter a Quota"
};

var importQuotas = {
  id: "0345accc-f9e7-45e0-9b33-e782a51a943f",
  defaultMessage: "Import quotas via Excel"
};

var documentTemplate = {
  id: "7c24d2f5-87c4-44ae-8eb1-439190bd0b39",
  defaultMessage: "File template"
};

var uploadDocument = {
  id: "9caff019-b2dd-4eb3-a39c-d99cf5a2d270",
  defaultMessage: "Import file"
};

var quotaValidityTitle = {
  id: "ba1d7ae2-995d-4b73-a90c-aec6dd5d5ad0",
  defaultMessage: "Quota validity period*"
};

var downloadDealers = {
  id: "4c40b110-5df4-4aa5-9e11-50217fdfcebd",
  defaultMessage: "Download dealer structure"
};

var downloadModels = {
  id: "63ae9182-c357-4ad0-aeec-39abe5af8819",
  defaultMessage: "Download model list"
};

var overlapsWillBeDeleted = {
  id: "9b06f6fe-3cd6-47a0-8171-ccce7427584d",
  defaultMessage: "Warning! A quota already exists for the set combination. Continuing will overwrite the existing quota."
};

export {
  Detail ,
  title ,
  dealerName ,
  createQuotaButton ,
  modalTitle ,
  createQuota ,
  importQuotas ,
  documentTemplate ,
  uploadDocument ,
  quotaValidityTitle ,
  downloadDealers ,
  downloadModels ,
  overlapsWillBeDeleted ,
}
/* No side effect */
